import { DomainGq, DomainGqProps } from './../../models/DomainGq';
import { QueryHookOptions } from '@apollo/client';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import gql from 'graphql-tag';

export function useGetCompetitivePerformanceGq(
  command: CommandGq,
  options: QueryHookOptions<DataGq, Variables> = {}
) {
  const query = useCustomQuery<DataGq, Variables>(gqTag, {
    ...options,
    variables: { command },
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getCompetitivePerformance,
  };
}

const gqTag = gql`
  query GetCompetitivePerformance($command: GetCompetitivePerformanceCommand!) {
    projects {
      getCompetitivePerformance(command: $command) {
        totalTraffic
        totalKeywordCount
        totalSearchVolume
        domainPerformanceAnalyses {
          domain {${DomainGqProps}}
          coveredKeywordCount
          coveredSearchVolume
          traffic
        }
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getCompetitivePerformance: ResponseGq;
  };
}

export interface ResponseGq {
  readonly totalTraffic: number;
  readonly totalKeywordCount: number;
  readonly totalSearchVolume: number;
  readonly domainPerformanceAnalyses: DomainPerformanceAnalysisGq[];
}

export interface DomainPerformanceAnalysisGq {
  readonly domain: DomainGq;
  readonly coveredKeywordCount: number;
  readonly coveredSearchVolume: number;
  readonly traffic: number;
}

export interface Variables {
  readonly command: CommandGq;
}

export interface CommandGq {
  readonly projectId: number;
  readonly domainIds: number[];
  readonly tagGroupId: number;
  readonly tagId: number;
  readonly rankValues: number[];
}
